import request from '@utils/fetch'

// 班级列表接口
export function selectClassInfoList(data) {
  return request({
    url: '/classInfoManage/selectClassInfoList',
    method: 'post',
    data
  })
}

// 移除班级接口
export function deleteClassInfo(data) {
  return request({
    url: '/classInfoManage/deleteClassInfo',
    method: 'delete',
    params: data
  })
}

// 班级列表接口
export function queryGradeAgeMonth(data) {
  return request({
    url: '/classInfoManage/queryGradeAgeMonth',
    method: 'post',
    data
  })
}

export function updateGradeAgeMonth(data) {
  return request({
    url: '/classInfoManage/updateGradeAgeMonth',
    method: 'post',
    data
  })
}